import axios, { ApiResponse, AppError, ErrorResponse } from "@/api/client";

export type MagicLinkArgs = {
  orgID: string;
  linkID: string;
  isProd: boolean;
};

export type MagicLink = {
  has_been_used: boolean;
  vendor: string;
  host?: string;
  bucket_vendor?: string;
  bucket_name?: string;
  bucket_access_id?: string;
  destination_name?: string;
  metastore?: string;
  recipient_id?: string;
  available_models: string[];
  redirect_url?: string;
  destination_docs_override?: string;
};

const getMagicLink = async (magiclinkargs: MagicLinkArgs): Promise<MagicLink> => {
  const environment = magiclinkargs.isProd ? "prod" : "staging";
  try {
    const response: ApiResponse<{ magic_link: MagicLink }> = await axios.get(
      `public/orgs/${magiclinkargs.orgID}/${environment}/magic-links/${magiclinkargs.linkID}`,
    );
    return response.data.data.magic_link;
  } catch (reason: any) {
    const errorResponse = reason as ErrorResponse;
    const e: AppError = {
      error: {
        message: errorResponse.response?.data?.message || "Failed to fetch magic link.",
        suppressGlobalNotification: true,
        statusCode: errorResponse.response?.status,
      },
    };
    throw e;
  }
};

const MagicLinkService = {
  getMagicLink,
};

export default MagicLinkService;
